<template>
    <div class="page page-choujiangjilu pr" >
        <!-- <div class="top">
            抽奖记录
        </div> -->
        <div class="list">
            <div class="list-item list-title clearfix" >
                <div class="el index">抽奖时间</div>
                <div class="el points">奖品</div>
            </div>
            <div class="list-item clearfix" v-for="(item, index) in list" :key='index'>
                <div class="line1" v-if="!index == 0"></div>
                <div class="line2"></div>
                <div class="line3" v-if="!(list.length == index+1)"></div>
                <div class="list-item-inner clearfix">
                    <div class="el index to">
                        {{item.createTime}}
                    </div>
                    <div class="el points to">{{item.giftName}}</div>
                </div>
            </div>
            <div class="btn-box">
                <div class="btn button1" v-if='isHaveMore' @click="onGetMore"><i class="el-icon-loading" v-if="isLoading"></i> 加载更多</div>
                <div class="btn button1" v-else @click="onGotoHome"> 没有更多记录了，继续做任务</div>
            </div>
        </div>
        
        
    </div>
</template>

<script>
import api from '@/assets/js/api'
import { cookie } from '@/assets/js/utils'
    export default {
        name: "notice",
        data() {
            return {
                actId: (window && window.actId),
               list: [{
                   createTime: '2020-22-22 22:33:99',
                   giftName: '5元话费'
               }],
               isLoading: false,
               pageNo: 1,
               isHaveMore: true,
               pageSize: 10
            }
        },
        methods: {
            onGotoHome(){
                this.$router.push('/')
            },

            
            async onload(){
                let self = this;
                let token = cookie.get('token'+self.actId);
                if(!token){
                    self.$message({
                        message: '请先登录'
                    })
                    self.$router.push('/')
                }
                self.isLoading = true;
                let res = await api({
                    method: 'myRunNote',
                    token,
                    pageNo: self.pageNo,
                    pageSize: self.pageSize
                }).catch(err => {
                    // console.log(err)
                })
                let {data, code ,msg} = res && res.data;
                // console.log(data, code ,msg)
                self.isLoading = false;
                if(code ==200){
                    if(self.pageNo == 1){
                        self.list = data.items;
                    }else{
                        self.list = self.list.concat(data.items);
                    }
                    self.isHaveMore = !(self.list.length >= data.total);

                }
                // console.log(self.list)
            },
            onGetMore(){
                let self = this;
                self.pageNo ++;
                self.onload();
            }
        },
        mounted() {
            let self =this;
            self.actId = self.query && self.query.__sa || (window && window.actId);
            this.onload()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '../../assets/css/base.less';

.page-choujiangjilu {
    padding-top: 40px;
    .btn-box {
        width: 100%;
        margin: 20px auto;
        .btn {
            text-align: center;
            color: #532d1d;
        }

    }
    .top {
        text-align: center;
        padding-bottom: 20px;
        color: @c-red;
        margin: 0 auto;
        width: unit(690 / @page-width * 100, vw);
        background-color: @c-bg;
        padding: unit(35 / @page-width * 100, vw);
        border-radius: 10px;
        margin-bottom: 20px;
        font-size: 28px;
    }

    .list {
        
        color: #6d5653 !important;
        box-sizing: border-box;
        background-color: #fffaf7;
        margin: 0 auto;
        width: unit(690 / @page-width * 100, vw);
        padding: unit(35 / @page-width * 100, vw);
        border-radius: 10px;
        .list-title {
            font-weight: bold;
            .index {
                color: @c-red !important;
                margin-left: 35px!important;
                width:unit(690 / @page-width * 100, vw);
            }
            .points {
                color: @c-red !important;
            }
        }
        .list-item {
            position: relative;
            padding: 5px 0;
            .line1 {
                position: absolute;
                left:5px;
                top: 0;
                height: 50%;
                width: 1px;
                background-color: @c-red;
            }
            .line2 {
                position: absolute;
                left:0px;
                top: 50%;
                height: 12px;
                margin-top: -6px;
                width: 12px;
                border-radius: 20px;
                background-color: @c-red;
            }
            .line3 {
                position: absolute;
                left:5px;
                bottom: 0;
                height: 50%;
                width: 1px;
                background-color: @c-red;
            }
            .list-item-inner {
                background-color: #fff;
                box-shadow: 0 0 7px #f0f0f0;
                border-radius: 5px;
                margin: 0 0 0 6vw;
            }
            &:last-child {
                border: 0;
            }
            // padding: 10px 0;
            .mr {
                margin-right: 10px;
            }
            // border-bottom: 1px solid #ead7b9;
            width: 100%;
            .el {
                line-height: 60px;
                height: 60px;
                float: left;
                text-align: center;
            }
            .index {
                .mr();
                text-align: left;
                margin-left: 10px;
                width: unit(320 / @page-width * 100, vw);
            }
            
            .points {
                float: right;
                width: unit(180 / @page-width * 100, vw);
                margin-right: 10px;
                color: #aa3b31;
                text-align: right;

            }
        }
    }
}

</style>